<template>
  <v-col>
    <h3>{{ $t("forecasts.alertsAmphibians.title") }}</h3>
    <v-simple-table>
      <tbody v-for="e in 2" :key="`slice${e}`">
        <tr>
          <th
            v-for="(day, b) in datatable.slice(e == 1 ? 0 : 7, e == 1 ? 7 : 14)"
            :key="`day${b}`"
          >
            {{ moment(day.date).format("ddd DD MMM") }}
          </th>
        </tr>

        <tr>
          <td
            v-for="(data, c) in datatable.slice(
              e == 1 ? 0 : 7,
              e == 1 ? 7 : 14
            )"
            :key="`days${c}`"
          >
            <v-tooltip :color="getDayCondition(data).couleur" top>
              <template v-slot:activator="{ on, attr }">
                <v-chip
                  v-bind="attr"
                  v-on="on"
                  class="white--text"
                  :color="getDayCondition(data).couleur"
                  ><b>{{ getDayCondition(data).texte }}</b></v-chip
                >
              </template>
              <span>
                <ul>
                  <li>
                    <b
                      >{{ $t("forecasts.alertsAmphibians.tempShort") }}
                      {{ Math.round((data.tmin + data.tmax) * 100) / 100 / 2 }}
                      °C</b
                    >
                  </li>
                  <li>
                    <b
                      >{{ $t("forecasts.alertsAmphibians.rain") }}:
                      {{ Math.round(data.rainmaxhor * 100) / 100 }} mm</b
                    >
                  </li>
                  <li>
                    <b
                      >{{ $t("forecasts.alertsAmphibians.wind") }}:
                      {{ Math.round(data.wind_speed) }} /
                      {{ Math.round(data.gustsfc) }} km/h</b
                    >
                  </li>
                </ul>
              </span>
            </v-tooltip>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </v-col>
</template>

<script>
import api from "@/api";
import moment from "moment";
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["user"]),
  },
  data: () => ({
    datatable: [],
    moment: moment,
  }),
  methods: {
    getConditionOfAlert(alerts, key) {
      let alert = alerts.find((map) => map.key == key);

      if (alert)
        switch (key) {
          case "wind":
            return alert.fcast > alert.number ? "red" : "green";
          case "temp-min":
            return alert.fcast < alert.number ? "red" : "green";
          case "temp-max":
            return alert.fcast > alert.number ? "red" : "green";
          case "rain-max":
            return alert.fcast > alert.number ? "red" : "green";
          case "snow":
            return alert.fcast > alert.number ? "red" : "green";
          case "storm":
            return alert.fcast > alert.number ? "red" : "green";
          case "ice":
            return alert.fcast > alert.number ? "red" : "green";
          case "rain-now":
            return alert.fcast > alert.number ? "red" : "green";
          default:
            break;
        }
    },
    hasAlert(alerts, key) {
      let alert = alerts.find((map) => map.key == key);
      if (alert.fcast || alert.fcast == 0) {
        return true;
      } else {
        return false;
      }
    },
    getUnit(key) {
      let unit = "";
      switch (key) {
        case "temp-min":
          unit = "°C";
          break;
        case "temp-max":
          unit = "°C";
          break;
        case "wind":
          unit = "km/h";
          break;
        case "rain-max":
          unit = "mm";
          break;
      }
      return unit;
    },
    displayDataWithKey(alerts, key) {
      let alert = alerts.find((map) => map.key == key);
      if (alert) {
        return alert.fcast;
      }
    },
    compte_risque_taxons(array) {
      var result;
      result = {
        0: 0,
        1: 0,
        2: 0,
      };
      var _key_;
      for (_key_ in array) {
        var val;
        val = array[_key_];
        result[val]++;
      }
      return result;
    },
    getDayCondition(data) {
      let previ = data;
      let temp_moy;
      temp_moy = (previ["tmin"] + previ["tmax"]) / 2;
      if (temp_moy >= 8 && temp_moy <= 20) {
        var val_temp;
        val_temp = 0;
      }
      if ((temp_moy >= 20) | (temp_moy <= 8)) {
        val_temp = 2;
      }
      if (previ["wind_speed"] * 3.6 >= 20) {
        var val_vent;
        val_vent = 2;
      }
      //| ($previ["gustsfc"]*3.6>=20)
      if (previ["rainmaxhor"] >= 5) {
        var val_pluie;
        val_pluie = 2;
      }
      var couleur;
      couleur = "green";
      var texte;
      texte = "idéal";
      var risques;
      risques = this.compte_risque_taxons({
        0: val_pluie,
        1: val_vent,
        2: val_temp,
      });
      if (risques[2] > 1) {
        var val;
        val = 2;
      } else {
        if (risques[2] == 1) {
          val = 1;
        } else {
          if (risques[1] > 1) {
            val = 1;
          } else {
            if (risques[1] == 1) {
              couleur = "green disabled";
              texte = "fav.";
            }
          }
        }
      }
      if (val == 1) {
        couleur = "orange";
        texte = "peu fav.";
      }
      if (val == 2) {
        couleur = "red";
        texte = "défav.";
      }

      return { couleur, texte };
    },
    async getData() {
      let res = await api.forecast.get(this.$route.params.geoname, 24);
      this.datatable = res.long;
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style>
</style>